import Modal from "components/global/modal";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  InstapaperShareButton,
  EmailShareButton,
  HatenaShareButton,
  LineShareButton,
  LivejournalShareButton,
  MailruShareButton,
  OKShareButton,
  PinterestShareButton,
  PocketShareButton,
  RedditShareButton,
  TelegramShareButton,
  TumblrShareButton,
  ViberShareButton,
  VKShareButton,
  WhatsappShareButton,
  WorkplaceShareButton,
  WeiboShareButton,
  EmailIcon,
  HatenaIcon,
  InstapaperIcon,
  LineIcon,
  LivejournalIcon,
  MailruIcon,
  OKIcon,
  PinterestIcon,
  PocketIcon,
  RedditIcon,
  TelegramIcon,
  TumblrIcon,
  ViberIcon,
  VKIcon,
  WeiboIcon,
  WhatsappIcon,
  FacebookIcon,
  LinkedinIcon,
  WorkplaceIcon,
  XIcon,
} from "react-share";
import { FaTimes } from "react-icons/fa";
import { useTranslation } from "react-i18next";


export default function ShareSocial({
  url,
  title = "turpis tincidunt id aliquet risus",
  description = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  image = "",
  hide = () => {},
  showMore = () => {},
}) {
  const { t } = useTranslation();
  const plainTextDescription = () => {
    // 1) Build a container that preserves whitespace
    const container = document.createElement('div');
    container.style.whiteSpace = 'pre-wrap';
    container.innerHTML = description;

    // 2) Replace <br> with literal newlines
    container.querySelectorAll('br').forEach(br => br.replaceWith('\n'));

    // 3) newlines after every <p> tag
    container.querySelectorAll('p').forEach(p => {
      // after the </p>
      p.parentNode.insertBefore(
        document.createTextNode('\n'),
        p.nextSibling
      );
    });

    // 4) Grab the text, turn NBSPs into normal spaces
    const raw = container.textContent || '';
    return raw.replace(/\u00A0/g, ' ');
  };

  return (
    <Modal
      width="w-11/12 1md:w-11/20"
      contentClassName="rounded-lg overflow-auto custom-scroll"
      wrapperClassName="overflow-visible shadow-none">
      <div className="w-full px-8 pt-4 pb-8 prounded-md">
        <div className="flex flex-row justify-between items-baseline mb-8">
          <p className="text-2xl font-bold">{t('share')}</p>
          {/* close */}
          <button onClick={() => hide()} className="mr-4">
            <FaTimes className="text-xl" />
          </button>
        </div>
        <div className="grid grid-cols-3 gap-4 sm:grid-cols-3 2md:grid-cols-4 profile-social-share-container">
          <FacebookShareButton
            url={url}
            quote={description}
            className="flex flex-col sm:flex-row item-center">
            <FacebookIcon size={45} className="mr-2" />
            <span className="text-[10px] md:text-lg">{t('facebook')}</span>
          </FacebookShareButton>
          <TwitterShareButton
            url={url}
            title={title}
            description={description}
            className="flex flex-col sm:flex-row item-center">
            <XIcon size={45} className="mr-2" />
            <span className="text-[10px] md:text-lg">{t('x')}</span>
          </TwitterShareButton>
          <LinkedinShareButton
            title={title}
            summary={description}
            url={url}
            className="flex flex-col sm:flex-row item-center">
            <LinkedinIcon size={45} className="mr-2" />
            <span className="text-[10px] md:text-lg">{t('linkedIn')}</span>
          </LinkedinShareButton>
          <WorkplaceShareButton
            url={url}
            quote={description}
            className="flex flex-col sm:flex-row item-center">
            <WorkplaceIcon size={45} className="mr-2" />
            <span className="text-[10px] md:text-lg">{t('workplace')}</span>
          </WorkplaceShareButton>
          <EmailShareButton
            url={url}
            subject={title}
            body={plainTextDescription()}
            className="flex flex-col sm:flex-row item-center">
            <EmailIcon size={45} className="mr-2" />
            <span className="text-[10px] md:text-lg">{t('email')}</span>
          </EmailShareButton>
          <InstapaperShareButton
            url={url}
            title={title}
            description={description}
            className="flex flex-col sm:flex-row item-center">
            <InstapaperIcon size={45} className="mr-2" />
            <span className="text-[10px] md:text-lg">{t('instapaper')}</span>
          </InstapaperShareButton>
          <HatenaShareButton
            url={url}
            title={title}
            className="flex flex-col sm:flex-row item-center">
            <HatenaIcon size={45} className="mr-2" />
            <span className="text-[10px] md:text-lg">{t('hatena')}</span>
          </HatenaShareButton>
          <LineShareButton
            url={url}
            title={title}
            className="flex flex-col sm:flex-row item-center">
            <LineIcon size={45} className="mr-2" />
            <span className="text-[10px] md:text-lg">{t('line')}</span>
          </LineShareButton>
          <LivejournalShareButton
            url={url}
            title={title}
            description={description}
            className="flex flex-col sm:flex-row item-center">
            <LivejournalIcon size={45} className="mr-2" />
            <span className="text-[10px] md:text-lg">{t('liveJournal')}</span>
          </LivejournalShareButton>
          <MailruShareButton
            url={url}
            title={title}
            description={description}
            imageUrl={image}
            className="flex flex-col sm:flex-row item-center">
            <MailruIcon size={45} className="mr-2" />
            <span className="text-[10px] md:text-lg">{t('mail.ru')}</span>
          </MailruShareButton>
          <OKShareButton
            url={url}
            title={title}
            image={image}
            description={description}
            className="flex flex-col sm:flex-row item-center">
            <OKIcon size={45} className="mr-2" />
            <span className="text-[10px] md:text-lg">{('OK')}</span>
          </OKShareButton>
          {image && (
            <PinterestShareButton
              url={url}
              media={image}
              description={title}
              className="flex flex-col sm:flex-row item-center">
              <PinterestIcon size={45} className="mr-2" />
              <span className="text-[10px] md:text-lg">{t('pinterest')}</span>
            </PinterestShareButton>
          )}
          <PocketShareButton
            url={url}
            title={title}
            className="flex flex-col sm:flex-row item-center">
            <PocketIcon size={45} className="mr-2" />
            <span className="text-[10px] md:text-lg">{t('pocket')}</span>
          </PocketShareButton>
          <RedditShareButton
            url={url}
            title={title}
            className="flex flex-col sm:flex-row item-center">
            <RedditIcon size={45} className="mr-2" />
            <span className="text-[10px] md:text-lg">{t('reddit')}</span>
          </RedditShareButton>
          <TelegramShareButton
            url={url}
            title={title}
            className="flex flex-col sm:flex-row item-center">
            <TelegramIcon size={45} className="mr-2" />
            <span className="text-[10px] md:text-lg">{t('telegram')}</span>
          </TelegramShareButton>
          <TumblrShareButton
            url={url}
            title={title}
            caption={description}
            className="flex flex-col sm:flex-row item-center">
            <TumblrIcon size={45} className="mr-2" />
            <span className="text-[10px] md:text-lg">{t('tumblr')}</span>
          </TumblrShareButton>
          <ViberShareButton
            url={url}
            title={title}
            caption={description}
            className="flex flex-col sm:flex-row item-center">
            <ViberIcon size={45} className="mr-2" />
            <span className="text-[10px] md:text-lg">{t('viber')}</span>
          </ViberShareButton>
          <VKShareButton
            url={url}
            title={title}
            image={image}
            className="flex flex-col sm:flex-row item-center">
            <VKIcon size={45} className="mr-2" />
            <span className="text-[10px] md:text-lg">{t('vK')}</span>
          </VKShareButton>
          <WhatsappShareButton
            url={url}
            title={title}
            className="flex flex-col sm:flex-row item-center">
            <WhatsappIcon size={45} className="mr-2" />
            <span className="text-[10px] md:text-lg">{t('whatsapp')}</span>
          </WhatsappShareButton>
          <WeiboShareButton
            url={url}
            title={title}
            image={image}
            className="flex flex-col sm:flex-row item-center">
            <WeiboIcon size={45} className="mr-2" />
            <span className="text-[10px] md:text-lg">{t('weibo')}</span>
          </WeiboShareButton>
        </div>
      </div>
    </Modal>
  );
}
